import { backendAPI } from '../../helper/apis'

export function makeGoogleAdmin(params) {
  return backendAPI.put(`/staff/makeadmin`, params);
}